import { useState } from 'react';

interface Steps {
    previous: () => void;
    next: () => void;
    currentStep: number;
}

export type StepsProps = {
    steps: Steps;
};

export const useSteps = (): Steps => {
    const [step, setStep] = useState(0);

    return {
        previous: () => {
            setStep(prev => prev - 1);
        },
        next: () => {
            setStep(prev => prev + 1);
        },
        currentStep: step
    };
};
